import { Link as GatsbyLink, navigate } from "gatsby"
import { gsap } from "gsap"
import React from "react"

function currentPage(target) {
  const linkPathName = new URL(getClosetLink(target).getAttribute("href"), window.location.origin).pathname
  return linkPathName !== window.location.pathname
}

const Link = ({ children, action = () => null, condition = () => true, to, ...props }) => {
  const onClick = event => {
    event.preventDefault()

    action(event, to)

    let timing = 1500
    if (window.innerWidth < 768) {
      timing = 100
    }

    if (condition(event, to)) {
      if (currentPage(event.target)) {
        setTimeout(function () {
          document.body.classList.remove("menu-open")
          document.body.classList.remove("submenu-open")
          document.body.classList.remove("third-open")
        }, timing)
        setTimeout(function () {
          document.body.classList.remove("alt-menu-open")
        }, 1200)
        document.querySelector(".menu-link.active")?.classList.remove("active")
        document.querySelector(".scrolling--header")?.classList.add("hidden")
        event.target.closest(".link")?.classList.add("transition")
        gsap.fromTo(
          "main",
          { opacity: 1 },
          {
            opacity: 0,
            y: 30,
            duration: 1,
            ease: "power3.inOut",
            onComplete: function () {
              navigate(to, { state: { internal: true } })
            },
          }
        )
      }
    }
  }
  return (
    <GatsbyLink to={to} {...props} onClick={event => onClick(event)}>
      {children}
    </GatsbyLink>
  )
}
export default Link

function getClosetLink(element) {
  return element.closest("a")
}
